import { Injectable } from "@angular/core";
import { of } from "rxjs";
import { APIService } from "src/app/api/api.service";
import { NotifierService } from "src/app/_services/notifier.service";
import { Observable, from } from "rxjs";
import { tap, finalize } from "rxjs/operators";

@Injectable({ providedIn: "root" })
export class StatusService {
  constructor(
    private apiServer: APIService,
    public notifier: NotifierService
  ) {}

  getLatestStatus() {
    this.notifier.loading(true);

    const apiURL = `https://rscrijtl30.execute-api.ap-south-1.amazonaws.com/dev/admin/process/status`;

    return from(this.apiServer.getDataPromis(apiURL, {}, {})).pipe(
      tap(() => this.notifier.loading(true)),
      finalize(() => this.notifier.loading(false))
    );
  }

  getStageDetail(test_guid: any) {
    this.notifier.loading(true);

    const apiURL = `https://rscrijtl30.execute-api.ap-south-1.amazonaws.com/dev/admin/process/status/${test_guid}`;

    const headers = {
      CacheBypass: new Date().getTime().toString(),
    };

    return from(this.apiServer.getDataPromis(apiURL, {}, {})).pipe(
      tap(() => this.notifier.loading(true)),
      finalize(() => this.notifier.loading(false))
    );
  }

  getSummary(fromDate: string, toDate: string) {
    this.notifier.loading(true);
    const params = new URLSearchParams({
      from: fromDate,
      to: toDate,
    });

    const apiURL = `https://rscrijtl30.execute-api.ap-south-1.amazonaws.com/dev/admin/process/status?${params.toString()}`;

    return from(this.apiServer.getDataPromis(apiURL, {}, {})).pipe(
      tap(() => this.notifier.loading(true)),
      finalize(() => this.notifier.loading(false))
    );
  }
}
